<style>
  .care {
    margin: 34px auto;
  }
</style>

<template>
  <div id="v-home">
    <eso-welcome></eso-welcome>
    <eso-care></eso-care>
  </div>
</template>

<script>
import esoWelcome from '../components/index/welcome'
import esoCare from '../components/index/care'

export default {
  name: 'home',
  components: {
    esoWelcome, esoCare
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?6f6088d5